import { render, staticRenderFns } from "./sch_zydltj.vue?vue&type=template&id=5b2c22d4&scoped=true"
import script from "./sch_zydltj.vue?vue&type=script&lang=js"
export * from "./sch_zydltj.vue?vue&type=script&lang=js"
import style0 from "./sch_zydltj.vue?vue&type=style&index=0&id=5b2c22d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c22d4",
  null
  
)

export default component.exports